import { render, staticRenderFns } from "./TableCustom.vue?vue&type=template&id=1d69284b&scoped=true"
import script from "./TableCustom.vue?vue&type=script&lang=js"
export * from "./TableCustom.vue?vue&type=script&lang=js"
import style0 from "./TableCustom.vue?vue&type=style&index=0&id=1d69284b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d69284b",
  null
  
)

export default component.exports